import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index'//主页
import museum from '@/pages/museum'//展馆主页
import poi from '@/pages/poi'//展馆主页





Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        path: '/index'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        // 页面标题title
        title: '百馆百址'
      }
    },
    {
      path: '/museum',
      name: 'museum',
      component: museum,
      meta: {
        // 页面标题title
      }
    },
    {
      path: '/poi',
      name: 'poi',
      component: poi,
      meta: {
        // 页面标题title
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js